// extracted by mini-css-extract-plugin
export default {"buttonRound":"Buttons_buttonRound__NfW6H","buttonSquare":"Buttons_buttonSquare__iVC7V"};